export default "__VITE_ASSET__81747424__"